import {
  Navbar,
  NavbarBrand,
  // NavbarContent,
  // NavbarItem,
  // Link,
  // Button,
} from "@heroui/react";
import logo from "../../../src/assets/img/MASH Primary logo White-aligned only text.svg";

export default function BasicNavbar() {
  return (
    <Navbar
      shouldHideOnScroll={false}
      position="sticky"
      isBlurred={false}
      className="bg-transparent text-white lg:max-w-screen-xl mx-auto"
      classNames={{ wrapper: " w-full max-w-full" }}
    >
      {/* Logo */}
      <NavbarBrand>
        <img src={logo} alt="Logo" className="h-7 w-auto" />
      </NavbarBrand>

      {/*
      <NavbarContent className="flex gap-12" justify="end">
        <NavbarItem className="hidden lg:flex">
          <Link
            href="https://docs.mash.fun/s/home"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white"
          >
            Docs
          </Link>
        </NavbarItem>

        <NavbarItem>
          <Button
            as={Link}
            href="https://app.mash.fun/"
            target="_blank"
            rel="noopener noreferrer"
            className="gradient-wild-bg rounded-md px-4 py-2"
          >
            Launch App
          </Button>
        </NavbarItem>
      </NavbarContent>
      */}
    </Navbar>
  );
}
